{
  "close": "Zatvoriť",
  "notifications": "Oznámenia"
}
